import type { ImageInspection } from './types';

const panImage = (
  inspection: ImageInspection,
  renderedSize: { width: number; height: number },
  delta: { x: number; y: number },
): ImageInspection => ({
  ...inspection,
  x: Math.max(0, Math.min(1, inspection.x - delta.x / renderedSize.width)),
  y: Math.max(0, Math.min(1, inspection.y - delta.y / renderedSize.height)),
});

export default panImage;
